import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import HomePage from '../pages/HomePage';
import StaticPage from '../pages/StaticPage';

// City pages are deliberately lazy-loaded. Each page statically imports only its own city
// config, so Vite can emit the city's topology/geometry/translations as an on-demand chunk.
const BucharestPage = lazy(() => import('../pages/BucharestPage'));
const ParisPage = lazy(() => import('../pages/ParisPage'));
const CopenhagenPage = lazy(() => import('../pages/CopenhagenPage'));
const StockholmPage = lazy(() => import('../pages/StockholmPage'));
const SofiaPage = lazy(() => import('../pages/SofiaPage'));
const PraguePage = lazy(() => import('../pages/PraguePage'));
const WarsawPage = lazy(() => import('../pages/WarsawPage'));
const BudapestPage = lazy(() => import('../pages/BudapestPage'));

export default function App() {
  return (
    <Suspense fallback={null}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/bucharest" element={<BucharestPage />} />
        <Route path="/paris" element={<ParisPage />} />
        <Route path="/copenhagen" element={<CopenhagenPage />} />
        <Route path="/stockholm" element={<StockholmPage />} />
        <Route path="/sofia" element={<SofiaPage />} />
        <Route path="/prague" element={<PraguePage />} />
        <Route path="/warsaw" element={<WarsawPage />} />
        <Route path="/budapest" element={<BudapestPage />} />
        <Route path="/about" element={<StaticPage title="About" />} />
        <Route path="/privacy" element={<StaticPage title="Privacy" />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}
